import React from "react";
import { Card, CardBody, CardHeader, Col, Row, Form, Label } from "reactstrap";
import Joi from "joi-browser";
import DefaultForm from "../common/defaultForm";
import userService from "../services/userService";
import projetoService from "../services/projetoService";
import { toast } from "react-toastify";
import Placeholder from "../common/placeholder";
import { parseISO } from "date-fns/esm";
import IMask from "imask";
import { NavigateFunction, Params, useNavigate, useParams } from "react-router-dom";

const cpfTestemunha1Mask = IMask.createMask({
  mask: "000.000.000-00",
  lazy: false,
  placeholderChar: "_",
});

const cpfTestemunha2Mask = IMask.createMask({
  mask: "000.000.000-00",
  lazy: false,
  placeholderChar: "_",
});


interface ProjetoFormProps {
  history: NavigateFunction,
  params: Readonly<Params<string>>,

}

interface ProjetoFormState {
  data: Projeto
}

class ProjetoForm extends DefaultForm<ProjetoFormProps> {


  state = {
    data: {
      projetoId: undefined,
      instituicaoExecutora: "",
      modalidade: "",
      banco: "",
      agencia: "",
      contaProjeto: "",
      nomeProjeto: "",
      coordenadorProjetoId: "",
      coordenadorChefeId: "",
      coordenadorUnidadeId: "",

      inicioProjeto: null,
      fimProjeto: null,
      nomeTestemunha1: "",
      nomeTestemunha2: "",
      rgTestemunha1: "",
      rgTestemunha2: "",
      cpfTestemunha1: "",
      cpfTestemunha1Masked: "",
      cpfTestemunha2: "",
      cpfTestemunha2Masked: "",
      emailTestemunha1: "",
      emailTestemunha2: "",
    },
    errors: {},
    coordenadores: [],
    assistentes: [],

    submitting: false,
    ready: false,
  };

  schema = {
    projetoId: Joi.string(),
    instituicaoExecutora: Joi.string().max(256).required().label("Instituição Executora"),
    modalidade: Joi.string().max(50).required().label("Modalidade"),
    nomeTestemunha1: Joi.string().max(256).required().label("Nome Testemunha 1"),
    nomeTestemunha2: Joi.string().max(256).required().label("Nome Testemunha 2"),
    rgTestemunha1: Joi.string().max(20).required().label("RG Testemunha 1"),
    rgTestemunha2: Joi.string().max(20).required().label("RG Testemunha 2"),
    cpfTestemunha1: Joi.string().min(11).max(11).required().label("CPF Testemunha 1"),
    cpfTestemunha1Masked: Joi.any(),
    cpfTestemunha2: Joi.string().min(11).max(11).required().label("CPF Testemunha 2"),
    cpfTestemunha2Masked: Joi.any(),
    emailTestemunha1: Joi.string().max(256).email().required().label("Email Testemunha 1"),
    emailTestemunha2: Joi.string().max(256).email().required().label("Email Testemunha 2"),
    banco: Joi.string().max(100).required().label("Banco"),
    agencia: Joi.string().max(20).required().label("Agência"),
    contaProjeto: Joi.string().max(100).required().label("Conta"),
    nomeProjeto: Joi.string().max(256).required().label("Projeto"),
    coordenadorChefeId: Joi.any().label("Coordenador Técnico"),
    coordenadorProjetoId: Joi.string().required().label("Coordenador do Projeto"),
    assistenteId: Joi.any().label("Assistente do Projeto"),
    coordenadorUnidadeId: Joi.any().label("Coordenador de Unidade"),
    inicioProjeto: Joi.date().required().label("Início do Projeto"),
    fimProjeto: Joi.date().required().label("Fim do Projeto"),
    coordenadorProjetoNome: Joi.any(),
    coordenadorUnidadeNome: Joi.any(),

  };

  async populateProjeto() {
    try {
      const projetoId = this.props.params.id;
      if (projetoId === "novo") {
        return;
      }

      let { data: projeto } = await projetoService.getProjeto(projetoId);
      projeto = {
        ...projeto,
        inicioProjeto: parseISO(projeto.inicioProjeto),
        fimProjeto: parseISO(projeto.fimProjeto),
        cpfTestemunha1Masked: cpfTestemunha1Mask.resolve(
          projeto.cpfTestemunha1 || ""
        ),
        cpfTestemunha1: cpfTestemunha1Mask.unmaskedValue,
        cpfTestemunha2Masked: cpfTestemunha2Mask.resolve(
          projeto.cpfTestemunha2 || ""
        ),
        cpfTestemunha2: cpfTestemunha2Mask.unmaskedValue,
      };
      delete projeto.coordenadorChefeNome;
      delete projeto.coordenadorUnidadeNome;
      delete projeto.assistenteNome;
      delete projeto.key;

      this.setState({ data: projeto });

    } catch (excpetion) {
      if (excpetion.response && excpetion.response.status === 404) {
        // this.props.history.replace("/404");
        console.log("ProjetoForm Exception", excpetion);
      }
    }
  }

  async getUsers() {
    const users = await userService.getUsers();

    const coordenadores = users
      .filter((c) => c.role === "Coordenador")
      .map((m) => ({ id: m.id, name: m.fullName }));

    const assistentes = users
      .filter((c) => c.role === "Assistente")
      .map((m) => ({ id: m.id, name: m.fullName }));

    this.setState({ coordenadores, assistentes });
  }

  async componentDidMount() {
    console.log("ProjetoForm didMount");

    const projetoPromise = this.populateProjeto();
    const usersPromise = this.getUsers();
    await projetoPromise;
    await usersPromise;
    this.setState({ ready: true });
  }

  dataToDto() {
    const data = this.state.data as any;
    const dto: Projeto = {
      instituicaoExecutora: data.instituicaoExecutora,
      modalidade: data.modalidade,
      banco: data.banco,
      agencia: data.agencia,
      contaProjeto: data.contaProjeto,
      nomeProjeto: data.nomeProjeto,
      coordenadorChefeId: data.coordenadorChefeId,
      coordenadorProjetoId: data.coordenadorProjetoId,
      coordenadorUnidadeId: data.coordenadorUnidadeId,
      assistenteId: data.assistenteId,

      inicioProjeto: data.inicioProjeto,
      fimProjeto: data.fimProjeto,
      nomeTestemunha1: data.nomeTestemunha1,
      nomeTestemunha2: data.nomeTestemunha2,
      rgTestemunha1: data.rgTestemunha1,
      rgTestemunha2: data.rgTestemunha2,
      cpfTestemunha1: data.cpfTestemunha1Masked,
      cpfTestemunha2: data.cpfTestemunha2Masked,
      emailTestemunha1: data.emailTestemunha1,
      emailTestemunha2: data.emailTestemunha2,
    };
    if (this.state.data.projetoId) {
      dto.projetoId = this.state.data.projetoId;
    }

    return dto;
  }

  doSubmit = async () => {
    try {
      const data = this.dataToDto();
      await projetoService.saveProjeto(data);
      if (this.state.data.projetoId) {
        toast.success("Sucesso! Projeto Atualizado.");
      } else {
        toast.success("Sucesso! Projeto Cadastrado.");
      }
      //TODO: use Contantans
      this.props.history("/gerenciamento/projetos");

    } catch (ex) {
      this.setState({ submitting: false });
      if (
        ex.response &&
        ex.response.status >= 400 &&
        ex.response.status < 500
      ) {
        this.setState({ errors: ex.response.data });
      }
    }
  };

  goBack = () => {
    this.props.history(-1);
  };

  render() {
    const isNew = this.props.params.id === "novo";

    return (
      <div className="animated fadeIn w-full  overflow-y-auto overflow-x-hidden">
        <Row>
          <Col xs={10}>
            <Card>
              <Placeholder ready={this.state.ready}>
                <CardHeader className="bg-light">
                  <i className="fa fa-align-justify pr-1" />
                  {isNew
                    ? "Cadastrar novo Projeto"
                    : `Editar Projeto: ${this.state.data.nomeProjeto}`}
                </CardHeader>
                <CardBody>
                  <Form onSubmit={this.handleSubmit}>
                    <Row>
                      <Col md={6}>
                        {this.renderInput(
                          "nomeProjeto",
                          "Projeto",
                          "text",
                          false,
                          false,
                          false,
                          true,
                          ""
                        )}
                        {this.renderInput(
                          "instituicaoExecutora",
                          "Instituição Executora",
                          "text",
                          false,
                          false,
                          false,
                          true,
                          ""
                        )}
                        <Row>
                          <Col md={6}>
                            {this.renderSelect(
                              "coordenadorChefeId",
                              this.state.coordenadores,
                              "Coordenador Técnico",
                              "name",
                              "id",
                              false,
                              false,
                              false,
                              true
                            )}
                          </Col>
                          <Col md={6}>
                            {this.renderSelect(
                              "coordenadorProjetoId",
                              this.state.coordenadores,
                              "Coordenador do Projeto",
                              "name",
                              "id",
                              false,
                              false,
                              false,
                              true
                            )}
                          </Col>
                        </Row>
                        <Row>
                          <Col md={6}>
                            {this.renderSelect(
                              "assistenteId",
                              this.state.assistentes,
                              "Assistente",
                              "name",
                              "id",
                              false,
                              false,
                              false,
                              true
                            )}
                          </Col>
                          <Col md={6}>
                            {this.renderSelect(
                              "coordenadorUnidadeId",
                              this.state.coordenadores,
                              "Coordenador de Unidade",
                              "name",
                              "id",
                              false,
                              false,
                              false,
                              true
                            )}
                          </Col>

                        </Row>

                        {this.renderInput(
                          "modalidade",
                          "Modalidade",
                          "text",
                          false,
                          false,
                          false,
                          true,
                          ""
                        )}
                      </Col>
                      <Col md={6}>
                        {this.renderDatePickerInput(
                          "inicioProjeto",
                          "Início do Projeto",
                          false,
                          false,
                          false,
                          true
                        )}
                        {this.renderDatePickerInput(
                          "fimProjeto",
                          "Fim do Projeto",
                          false,
                          false,
                          false,
                          true
                        )}

                        {this.renderInput(
                          "banco",
                          "Banco",
                          "text",
                          false,
                          false,
                          false,
                          true,
                          "Número e Nome",
                          ""
                        )}
                        <Row>
                          <Col md={6}>
                            {this.renderInput(
                              "agencia",
                              "Agência",
                              "text",
                              false,
                              false,
                              false,
                              true,
                              "Sem dígito"
                            )}
                          </Col>
                          <Col md={6}>
                            {this.renderInput(
                              "contaProjeto",
                              "Conta",
                              "text",
                              false,
                              false,
                              false,
                              true,
                              "Com dígito"
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6}>
                        <Label
                          for={"nomeTestemunha1"}
                          className={"font-weight-bold"}
                        >
                          {"Testemunha 1"}
                        </Label>
                        {this.renderInput(
                          "nomeTestemunha1",
                          "Nome",
                          "text",
                          false,
                          false,
                          false,
                          true,
                          ""
                        )}
                        {this.renderInput(
                          "rgTestemunha1",
                          "RG",
                          "text",
                          false,
                          false,
                          false,
                          true,
                          "",
                        )}
                        {this.renderInput(
                          "cpfTestemunha1",
                          "CPF",
                          "text",
                          false,
                          false,
                          false,
                          true,
                          "",
                          cpfTestemunha1Mask
                        )}
                        {this.renderInput(
                          "emailTestemunha1",
                          "Email",
                          "text",
                          false,
                          false,
                          false,
                          true,
                          "",
                        )}
                      </Col>
                      <Col md={6}>
                        <Label
                          for={"nomeTestemunha2"}
                          className={"font-weight-bold"}
                        >
                          {"Testemunha 2"}
                        </Label>
                        {this.renderInput(
                          "nomeTestemunha2",
                          "Nome",
                          "text",
                          false,
                          false,
                          false,
                          true,
                          "",
                        )}
                        {this.renderInput(
                          "rgTestemunha2",
                          "RG",
                          "text",
                          false,
                          false,
                          false,
                          true,
                          "",
                        )}
                        {this.renderInput(
                          "cpfTestemunha2",
                          "CPF",
                          "text",
                          false,
                          false,
                          false,
                          true,
                          "",
                          cpfTestemunha2Mask
                        )}
                        {this.renderInput(
                          "emailTestemunha2",
                          "Email",
                          "text",
                          false,
                          false,
                          false,
                          true,
                          "",
                        )}
                      </Col>
                    </Row>
                    {this.renderButton("Salvar")}
                    <button
                      type="button"
                      onClick={this.goBack}
                      className={"btn btn-secondary ml-3"}>
                      Voltar
                    </button>
                  </Form>
                </CardBody>
              </Placeholder>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default (props) => (
  <ProjetoForm history={useNavigate()} params={useParams()} />
);